import React, {useEffect, useMemo, useRef, useState} from "react";
import {
    Box,
    Button,
    ButtonGroup, Collapse,
    FormControl, IconButton, inputBaseClasses,
    InputLabel,
    MenuItem,
    Paper,
    Select,
    Stack,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow, TextField,
    Typography
} from "@mui/material";

import {usePDF} from 'react-to-pdf';
import {useWebSocket} from "../net/WebSocketContext";
import BlurredComponent_all from "../common/BlurredComponent_all";
import AlertDialog from "../common/Dialog";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {ExpandMore} from "@mui/icons-material";
import {styled} from "@mui/material/styles";
import JudgeSelector from "./JudgeSelector";
import DigitDialog from "./DigitDialog";
import MassDanceDialog from "./MassDanceDialog";
import MassNextRoundDialog from "./MassNextRoundDialog";
import { getBalls,getBallsJJ, getScore, roundTo3, fixNaN, getSkatingPlaces} from '../common/CalculateScores';
import AlertDialogNote from "../common/DialogNote";
import ReactMarkdown from "react-markdown";
import VideoPlayer from "../common/VideoPlayer";

const Sets = ({darkMode, setDarkMode}) => {
    const {toPDF, targetRef} = usePDF({
        page: {
            // margin is in MM, default is Margin.NONE = 0
            margin: 2,
            // default is 'A4'
            format: 'A4',
            // default is 'portrait'
            orientation: 'portrait',
        },
        method: "open",
        filename: 'page.pdf'
    });
    const {ws, isConnected, ws_data, progress, loading,
        sets,
        users_list,
        all_users_list,
        refresh
    } = useWebSocket();
    const [dance_set, setDanceSet] = useState({});
    const [dance_set_slow, setDanceSetSlow] = useState({});
    const [dance_set_arr, setDanceSetArr] = useState([]);
    const [dance_set_obj, setDanceSetObj] = useState({
        leaders: [],
        followers: []
    });
    const [generated, setGenerated] = useState(false);
    const [dance_complete, setDance_complete] = useState(false);
    const [final_complete, setFinal_complete] = useState(false);
    const [events, setEvents] = useState([]);
    const [users, setUsers] = useState([]);
    const [wait, setWait] = useState(false);
    const [isDone, setIsDone] = useState(false);
    const [isPrint, setIsPrint] = useState(false);
    const [isEnd, setIsEnd] = useState(false);
    const [isEndJudging, setIsEndJudging] = useState(false);
    const [isSort, setIsSort] = useState(false);
    const [start, setStart] = useState(false);
    const [selectListRound, setSelectListRound] = useState(0);
    const [pair_count, setPairCount] = useState(10);
    const [massDialogOpen, setMassDialogOpen] = useState(false);
    const [massNextRoundDialogOpen, setMassNextRoundDialogOpen] = useState(false);
    const [selectedJudges, setSelectedJudges] = useState({
        leaders: [
            "17a19603-6076-420e-ba3e-9ce9fe913540",
            "27a19603-6076-420e-ba3e-9ce9fe913540",
            "37a19603-6076-420e-ba3e-9ce9fe913540",
            "47a19603-6076-420e-ba3e-9ce9fe913540",
            "57a19603-6076-420e-ba3e-9ce9fe913540",
            "67a19603-6076-420e-ba3e-9ce9fe913540",
            "77a19603-6076-420e-ba3e-9ce9fe913540"
        ],
        followers: [

            "87a19603-6076-420e-ba3e-9ce9fe913540",
            "97a19603-6076-420e-ba3e-9ce9fe913540",
            "10a19603-6076-420e-ba3e-9ce9fe913540"]
    });
    const [jjBalls, setJjBalls] = useState({
        yes: 0,
        maybe: 0
    })
    const [filters, setFilters] = useState(() => {
        return (
            JSON.parse(localStorage.getItem("sets_filters")) ||
            {
                event: null,
                dance: "",
                category: "",
                class: "",
                round: ""
            })
    });
    const filters_ref = useRef({});
    const [personalFinal, setPersonalFinal] = useState(false);
    const [personalRound, setPersonalRound] = useState(true);
    const [users_id, setUsers_id] = useState([]);


    const [judType, setjudType] = useState();
    const printPDF = async () => {
        const darkModeTmp = darkMode
        if (darkMode) {
            await setDarkMode(false)
            await setIsPrint(true)
        }
        await toPDF()
        await setIsPrint(false)
        setDarkMode(darkModeTmp)
    }

    useEffect(() => {
        filters_ref.current = JSON.parse(localStorage.getItem("sets_filters")) ||
            {
                event: null,
                dance: "",
                category: "",
                class: "",
                round: ""
            };

    }, []);
    useEffect(() => {
        localStorage.setItem("sets_filters", JSON.stringify(filters));
    }, [filters]);
    useEffect(() => {
        if (
            filters.event === null ||
            filters.dance === null ||
            filters.category === null ||
            filters.class === null

        ) {
            getUserList()
            return
        }
        getAllUsers()
        //console.log(filters.event)
        if (ws && ws.readyState === WebSocket.OPEN) {
            let body = {
                action: "sets",
                event: filters.event?.event?.value ?? null,
                dance: filters.dance,
                category: filters.category,
                class: filters.class,
                round: filters?.round ?? false
            }
            //setWait(true)
            ws.zsend(JSON.stringify(body));
            console.log("SEND:", body);
        } else console.log("Нет готовности отправлять по ws ")
    }, []);

    useEffect(() => {
        getSetRefresh()
    }, [refresh]);
    useEffect(() => {
        if (users_list?.users_list) {
            setUsers(users_list.users_list);
        }
        if (users_list?.events) {
            setEvents(users_list?.events);
        }
    }, [users_list]);
    useEffect(() => {

        if (sets?.users_list) {
            setUsers(sets.users_list);
        }
        if (sets?.events) {
            setEvents(sets?.events);
        }

        if (sets?.jud_type) {
            setjudType(sets?.jud_type);
        }


        if (sets?.set) {
            setDanceSet(sets);
            if (sets?.category === "Strictly" || sets?.jud_type === "Strictly" ) {
                setDanceSetArr(sets?.set)
            }
            if (sets?.category === "Skating" || sets?.jud_type === "Skating" ) {
                setDanceSetArr(sets?.set)
            }
            if (sets?.category === "J&J" || sets?.jud_type === "J&J") {
                setDanceSetObj(
                    {
                        leaders: [...sets?.set.filter(f => f?.leader?.id)],
                        followers: [...sets?.set.filter(f => f?.follower?.id)]
                    })
                setDanceSetArr([...sets?.set.filter(f => f?.leader?.id)])
            }
            setGenerated(sets?.generated);
        }
        if (sets?.slow) {
            setDanceSetSlow(sets?.slow);
        }
        if (sets?.init_set) {
            setJjBalls(sets?.init_set?.jjBalls)
            setPairCount(sets?.init_set?.pair_count)
        }
        if (sets?.judging_list) {
            setSelectedJudges(sets?.judging_list)
        }

    }, [sets]);
    useEffect(() => {
        console.log("all_users_list",all_users_list)
        if (isConnected && all_users_list?.users){
            setUsers_id(prev => [...prev, ...all_users_list?.users ])
        }
    }, [all_users_list]);


    // useEffect(() => {
    //     if (isConnected && ws_data) {
    //         console.log("ON_MESSAGE Sets", ws_data)
    //         if (ws_data.type === "refresh") {
    //
    //         }
    //         if (ws_data.type === "users_list") {
    //             if (ws_data?.users_list) {
    //                 setUsers(ws_data.users_list);
    //             }
    //             if (ws_data.events) {
    //                 setEvents(ws_data.events);
    //             }
    //         }
    //         if (ws_data.type === "sets") {
    //             if (ws_data?.users_list) {
    //                 setUsers(ws_data.users_list);
    //             }
    //             if (ws_data?.events) {
    //                 setEvents(ws_data.events);
    //             }
    //
    //             if (ws_data?.jud_type) {
    //                 setjudType(ws_data?.jud_type);
    //             }
    //
    //
    //             if (ws_data?.set) {
    //                 setDanceSet(ws_data);
    //                 if (ws_data?.category === "Strictly" || ws_data?.jud_type === "Strictly" ) {
    //                     setDanceSetArr(ws_data.set)
    //                 }
    //                 if (ws_data?.category === "Skating" || ws_data?.jud_type === "Skating" ) {
    //                     setDanceSetArr(ws_data.set)
    //                 }
    //                 if (ws_data?.category === "J&J" || ws_data?.jud_type === "J&J") {
    //                     setDanceSetObj(
    //                         {
    //                             leaders: [...ws_data?.set.filter(f => f?.leader?.id)],
    //                             followers: [...ws_data?.set.filter(f => f?.follower?.id)]
    //                         })
    //                     setDanceSetArr([...ws_data?.set.filter(f => f?.leader?.id)])
    //                 }
    //                 setGenerated(ws_data?.generated);
    //             }
    //             if (ws_data?.slow) {
    //                 setDanceSetSlow(ws_data?.slow);
    //             }
    //             if (ws_data?.init_set) {
    //                 setJjBalls(ws_data?.init_set?.jjBalls)
    //                 setPairCount(ws_data?.init_set?.pair_count)
    //             }
    //             if (ws_data?.judging_list) {
    //                 setSelectedJudges(ws_data?.judging_list)
    //             }
    //         }
    //         if (ws_data.type === "all_users_list") {
    //             setUsers_id(prev => [...prev, ...ws_data?.users ])
    //             console.log("all_users_list",ws_data)
    //         }
    //     }
    //     setWait(false)
    // }, [ws_data]);
    // useEffect(() => {
    //     for (const item of users_id) {
    //         if (item.email === "") {
    //             console.log("item.name",item.name, item._id)
    //             if (ws && ws.readyState === WebSocket.OPEN) {
    //                 let body = {
    //                     action: "find_user",
    //                     user_id: item._id
    //                 }
    //                 ws.zsend(JSON.stringify(body));
    //                 console.log("SEND:", body);
    //             } else console.log("Нет готовности отправлять по ws ")
    //         }
    //     }
    //
    // }, [users_id]);

    const getAllUsers = () => {
        if (!ws) {
            console.log("Нет готовности отправлять по ws")
            return;
        }
        const sendOnOpen = () => {
            //setWait(true)
            ws.zsend(JSON.stringify({action: "all_users_list"}));
            console.log("SEND:", {action: "all_users_list"});
        };
        if (ws.readyState === WebSocket.OPEN) {
            sendOnOpen();
        } else {
            ws.addEventListener("open", sendOnOpen);
        }
        return () => {
            ws.removeEventListener("open", sendOnOpen);
        };
    }

    const getUserList = () => {
        if (!ws) {
            console.log("Нет готовности отправлять по ws")
            return;
        }
        const sendOnOpen = () => {
            //setWait(true)
            ws.zsend(JSON.stringify({action: "users_list"}));
            console.log("SEND:", {action: "users_list"});
        };
        if (ws.readyState === WebSocket.OPEN) {
            sendOnOpen();
        } else {
            ws.addEventListener("open", sendOnOpen);
        }
        return () => {
            ws.removeEventListener("open", sendOnOpen);
        };
    }
    //Алгоритм Фишера–Йетса для случайного перемешивания.
    const shuffleDanceSet = () => {
        setOpenCollapse(false);
        const shuffledArray = [...dance_set?.set]; // Копируем массив
        for (let i = shuffledArray.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1)); // Случайный индекс
            [shuffledArray[i], shuffledArray[j]] = [shuffledArray[j], shuffledArray[i]]; // Меняем местами
        }
        if (ws && ws.readyState === WebSocket.OPEN) {
            let body = {
                action: "sets",
                init_set: {
                    pair_count,
                    jjBalls
                },
                judging_list: personalFinal || personalRound ? selectedJudges : {
                    leaders: [...selectedJudges?.leaders, ...selectedJudges?.followers],
                    followers: []
                },
                write: true,
                event: filters.event?.event?.value ?? null,
                dance: filters.dance,
                category: filters.category,
                class: filters.class,
                round: filters?.round ?? false,
                dance_set: shuffledArray
            }
            //setWait(true)
            ws.zsend(JSON.stringify(body));
            console.log("SEND:", body);
        } else {
            console.log("Нет готовности отправлять по ws ")
        }
    };
    const endDanceSet = () => {
        setOpenCollapse(false);
        setIsEndJudging(true)
        const danceSet = [...dance_set?.set]; // Копируем массив
        if (ws && ws.readyState === WebSocket.OPEN) {
            let body = {
                action: "sets",
                init_set: {
                    pair_count,
                    jjBalls
                },
                judging_list: selectedJudges,
                write: true,
                end: true,
                event: filters.event?.event?.value ?? null,
                dance: filters.dance,
                category: filters.category,
                class: filters.class,
                round: filters?.round ?? false,
                dance_set: danceSet
            }
            //setWait(true)
            ws.zsend(JSON.stringify(body));
            console.log("SEND:", body);
        } else {
            console.log("Нет готовности отправлять по ws ")
        }
    };
    const getSet = () => {
        if (ws && ws.readyState === WebSocket.OPEN) {
            let body = {
                action: "sets",
                event: filters.event?.event?.value ?? null,
                dance: filters.dance,
                category: filters.category,
                class: filters.class,
                round: filters?.round ?? false,
            }
            //setWait(true)
            setIsDone(false)
            setIsEnd(false)
            setStart(false)
            ws.zsend(JSON.stringify(body));
            console.log("SEND:", body);
        } else {
            console.log("Нет готовности отправлять по ws ")
        }
    };
    const rmSet = () => {
        if (ws && ws.readyState === WebSocket.OPEN) {
            let body = {
                action: "sets",
                remove: true,
                event: filters.event?.event?.value ?? null,
                dance: filters.dance,
                category: filters.category,
                class: filters.class,
                round: filters?.round ?? false,
            }
            //setStart(false)
            //setWait(true)
            ws.zsend(JSON.stringify(body));
            console.log("SEND:", body);
        } else {
            console.log("Нет готовности отправлять по ws ")
        }
    };
    const getSetR = () => {
        if (ws && ws.readyState === WebSocket.OPEN) {
            let body = {
                action: "sets",
                event: filters_ref.current.event?.event?.value ?? null,
                dance: filters_ref.current.dance,
                category: filters_ref.current.category,
                class: filters_ref.current.class,
                round: filters_ref?.current.round ?? false,
            }
            if(filters_ref?.current?.category === "J&J" || judType === "J&J"){
                setPairCount(10)
            }
            if(filters_ref?.current?.category === "Strictly" || judType === "Strictly"){
                setPairCount(1)
            }
            setIsEndJudging(false)
            //setWait(true)
            setIsDone(false)
            setIsEnd(false)
            setStart(false)
            setSelectedJudges({
                leaders: [],
                followers: []
            })
            ws.zsend(JSON.stringify(body));
            console.log("SEND:", body);
        } else {
            console.log("Нет готовности отправлять по ws ")
        }
    };
    const getSetRefresh = () => {
        if (ws && ws.readyState === WebSocket.OPEN) {
            let body = {
                action: "sets",
                event: filters_ref.current.event?.event?.value ?? null,
                dance: filters_ref.current.dance,
                category: filters_ref.current.category,
                class: filters_ref.current.class,
                round: filters_ref?.current.round ?? false,
            }
            if(filters_ref?.current?.category === "J&J" || judType === "J&J"){
                setPairCount(10)
            }
            if(filters_ref?.current?.category === "Strictly" || judType === "Strictly"){
                setPairCount(1)
            }
            ws.zsend(JSON.stringify(body));
            console.log("SEND:", body);
        } else {
            console.log("Нет готовности отправлять по ws ")
        }
    };
    const rounds = () => {
        return events.filter(event => (event?.event?.value ?? null) === filters?.["event"]?.event?.value)?.[0]?.['roundList']?.[filters?.["dance"]]?.[filters?.["category"]]?.[filters?.["class"]] ?? []
    }
    const toDance = (place, event, dance, category, dance_class, round, number, leader, follower, roles) => {
        if (ws && ws.readyState === WebSocket.OPEN) {
            let body = {
                action: "judging_start",
                place, event, dance, category, class: dance_class, round, number, leader, follower, selectedJudges, roles
            }
            //setWait(true)
            ws.zsend(JSON.stringify(body));
            console.log("SEND:", body);
        } else {
            console.log("Нет готовности отправлять по ws ")
        }
    }
    const toNextRoundMass = (count, event, dance, category, dance_class, round, personalFinal, personalRound) => {
        const nextRound = getNextRound(round);
        // Собираем ID пользователей в порядке сортировки (как на фронтенде)
        let sortedUserIds = [];
        if (filters?.category === "J&J" || judType === "J&J") {
            const leaders = [...(sortedDataObj?.leaders ?? [])].sort((a, b) => {
                let valueA = getBallsJJ(a?.leader?.id, dance_set, users) ?? 0;
                let valueB = getBallsJJ(b?.leader?.id, dance_set, users) ?? 0;
                return Number(valueB) - Number(valueA);
            }).map(e => e.leader?.id).filter(Boolean);
            const followers = [...(sortedDataObj?.followers ?? [])].sort((a, b) => {
                let valueA = getBallsJJ(a?.follower?.id, dance_set, users) ?? 0;
                let valueB = getBallsJJ(b?.follower?.id, dance_set, users) ?? 0;
                return Number(valueB) - Number(valueA);
            }).map(e => e.follower?.id).filter(Boolean);
            // Перемешиваем лидеров и фолловеров по порядку
            const maxLen = Math.max(leaders.length, followers.length);
            for (let i = 0; i < maxLen; i++) {
                if (i < leaders.length) sortedUserIds.push(leaders[i]);
                if (i < followers.length) sortedUserIds.push(followers[i]);
            }
        } else {
            sortedUserIds = [...(sortedData ?? [])].sort((a, b) => {
                let valueA = (getBalls(a?.leader?.id, dance_set, users) ?? 0) + (getBalls(a?.follower?.id, dance_set, users) ?? 0) * 0.1;
                let valueB = (getBalls(b?.leader?.id, dance_set, users) ?? 0) + (getBalls(b?.follower?.id, dance_set, users) ?? 0) * 0.1;
                return Number(valueB) - Number(valueA);
            }).flatMap(e => [e.leader?.id, e.follower?.id].filter(Boolean));
        }
        if (ws && ws.readyState === WebSocket.OPEN) {
            const body = {
                action: "judging_to_next_round_mass",
                count,
                event,
                dance,
                category,
                class: dance_class,
                current_round: round,
                round: nextRound,
                personalFinal,
                personalRound,
                sorted_user_ids: sortedUserIds
            };
            ws.zsend(JSON.stringify(body));
            console.log("SEND NEXT ROUND MASS:", body);
        } else {
            console.log("Нет готовности отправлять по ws ")
        }
    }

    const toDanceMass = (count, event, dance, category, dance_class, round, roles) => {
        if (ws && ws.readyState === WebSocket.OPEN) {
            const body = {
                action: "judging_start_mass",
                count,
                event,
                dance,
                category,
                class: dance_class,
                round,
                selectedJudges,
                roles
            };
            ws.zsend(JSON.stringify(body));
            console.log("SEND MASS:", body);
        } else {
            console.log("Нет готовности отправлять по ws ")
        }
    }
    const cancelDance = (place, event, dance, category, dance_class, round, number, leader, follower, roles) => {
        if (ws && ws.readyState === WebSocket.OPEN) {
            let body = {
                action: "judging_cancel",
                place, event, dance, category, class: dance_class, round, number, leader, follower, selectedJudges, roles
            }
            //setWait(true)
            ws.zsend(JSON.stringify(body));
            console.log("SEND:", body);
        } else {
            console.log("Нет готовности отправлять по ws ")
        }
    }
    const cancelDanceMass = (event, dance, category, dance_class, round) => {
        if (ws && ws.readyState === WebSocket.OPEN) {
            const body = {
                action: "judging_cancel_mass",
                event,
                dance,
                category,
                class: dance_class,
                round,
            };
            ws.zsend(JSON.stringify(body));
            console.log("SEND CANCEL MASS:", body);
        } else {
            console.log("Нет готовности отправлять по ws ")
        }
    }
    const cancelNextRoundMass = (event, dance, category, dance_class, round) => {
        if (ws && ws.readyState === WebSocket.OPEN) {
            const body = {
                action: "judging_to_next_round_mass_cancel",
                event,
                dance,
                category,
                class: dance_class,
                current_round: round,
                round: getNextRound(round)
            };
            ws.zsend(JSON.stringify(body));
            console.log("SEND CANCEL NEXT ROUND MASS:", body);
        } else {
            console.log("Нет готовности отправлять по ws ")
        }
    }
    const toFinal = (place, event, dance, category, dance_class, round, number, leader, follower) => {
        if (ws && ws.readyState === WebSocket.OPEN) {
            let body = {
                action: "judging_to_final",
                place, event, dance, category, class: dance_class, round, number, leader, follower
            }
            //setWait(true)
            ws.zsend(JSON.stringify(body));
            console.log("SEND:", body);
        } else {
            console.log("Нет готовности отправлять по ws ")
        }
    }
    const getNextRound = (current_round) =>{
        const roundList = filters?.event?.roundList?.[filters?.dance]?.[filters?.category]?.[filters?.class] ?? []
        //console.log("getNextRound",[filters?.dance],[filters?.category],[filters?.class])
        //console.log("getNextRound",roundList, filters?.event)
        return roundList[(roundList)?.indexOf(current_round)+1] ?? false
    }
    const toNextRound = (place, event, dance, category, dance_class, round, number, leader, follower) => {
        if (ws && ws.readyState === WebSocket.OPEN) {
            const nextRound = getNextRound(round)
            let body = {
                action: "judging_to_next_round",
                place, event, dance, category, class: dance_class,
                round:nextRound,
                number, leader, follower, personalFinal, personalRound
            }
            //setWait(true)
            ws.zsend(JSON.stringify(body));
            console.log("SEND:", body);
        } else {
            console.log("Нет готовности отправлять по ws ")
        }
    }
    const toNextRoundCancel = (place, event, dance, category, dance_class, round, number, leader, follower) => {
        if (ws && ws.readyState === WebSocket.OPEN) {
            const nextRound = getNextRound(round)
            let body = {
                action: "judging_to_next_round_cancel",
                place, event, dance, category, class: dance_class,
                round:nextRound,
                number, leader, follower, personalFinal
            }
            //setWait(true)
            ws.zsend(JSON.stringify(body));
            console.log("SEND:", body);
        } else {
            console.log("Нет готовности отправлять по ws ")
        }
    }
    const getFinal = (leader_id, dance_set_) => {
        return users.find(u => u._id === leader_id)
            ?.['events']
            ?.[dance_set_?.event]
            ?.['danceSelections']
            ?.[dance_set_?.dance]
            ?.[dance_set_?.category]
            ?.['cards']
            ?.['slow_final']
            ?.[dance_set_?.class]?.final
    }
    const getRoundAccess = (user_id, dance_set_, round) => {
        return users.find(u => u._id === user_id)
            ?.['events']
            ?.[dance_set_?.event]
            ?.['danceSelections']
            ?.[dance_set_?.dance]
            ?.[dance_set_?.category]
            ?.['cards']
            ?.[round]
            ?.[dance_set_?.class]?.[round]
    }
    // Сортировка J&J
    const sortedDataObj = useMemo(() => {
        if (isDone || isSort) {
            return {
                leaders: [...dance_set_obj?.leaders].sort((a, b) => {
                    let valueA, valueB
                        valueA = getBallsJJ(a?.leader?.id, dance_set,users)
                        valueB = getBallsJJ(b?.leader?.id, dance_set,users)
                    return Number(valueB) - Number(valueA);
                }),
                followers: [...dance_set_obj?.followers].sort((a, b) => {
                    let valueA, valueB
                    valueA = getBallsJJ(a?.follower?.id, dance_set,users)
                    valueB = getBallsJJ(b?.follower?.id, dance_set,users)
                    return Number(valueB) - Number(valueA);
                })
            }
        } else {
            return dance_set_obj;
        }
    }, [dance_set_obj, isDone, isSort])
    // Сортировка Strictly\Skating
    const sortedData = useMemo(() => {
        if (isDone || isSort) {
            const result = [...dance_set_arr].sort((a, b) => {
                let valueA, valueB
                if (dance_set?.round === "fast" || dance_set?.round === "fast_final") {
                    valueA = roundTo3((getBalls(a?.leader?.id, dance_set,users) + (getBalls(a?.leader?.id, dance_set,users) * 0.1)) + getBalls(a?.leader?.id, dance_set_slow, users))
                    valueB = roundTo3((getBalls(b?.leader?.id, dance_set,users) + (getBalls(b?.leader?.id, dance_set,users) * 0.1)) + getBalls(b?.leader?.id, dance_set_slow, users))
                } else {
                    valueA = getBalls(a?.leader?.id, dance_set,users) ?? "";
                    valueB = getBalls(b?.leader?.id, dance_set,users) ?? "";
                }
                return Number(valueB) - Number(valueA);
            });
            console.log("result",result)
            return result
        } else {
            return dance_set_arr
        }
    }, [dance_set_arr, isDone, isSort]);

    const sortedDataSkating = useMemo(() => {
        if (isDone || isSort) {
            const result =
             personalRound  || filters?.round === "1"? // if skating?
                [...dance_set_arr].sort((a, b) => {
                let valueA, valueB
                    valueA = getSkatingPlaces(a?.leader?.id, dance_set,users) ?? "";
                    valueB = getSkatingPlaces(b?.leader?.id, dance_set,users) ?? "";
                return Number(valueA) - Number(valueB);
            } )
            :   //else jj
            [...dance_set_arr].sort((a, b) => {
                let valueA, valueB
                valueA = getBallsJJ(a?.leader?.id, dance_set,users)
                valueB = getBallsJJ(b?.leader?.id, dance_set,users)
                return Number(valueB) - Number(valueA);
            } )
            console.log("result",result)
            return result
        } else {
            return dance_set_arr
        }
    }, [dance_set_arr, isDone, isSort]);

    const sortedDataSkatingObj = useMemo(() => {
        if (isDone || isSort) {
            return {
                leaders: [...dance_set_obj?.leaders].sort((a, b) => {
                    let valueA, valueB
                    valueA = getSkatingPlaces(a?.leader?.id, dance_set,users) ?? "";
                    valueB = getSkatingPlaces(b?.leader?.id, dance_set,users) ?? "";
                    return Number(valueB) - Number(valueA);
                }),
                followers: [...dance_set_obj?.followers].sort((a, b) => {
                    let valueA, valueB
                    valueA = getSkatingPlaces(a?.follower?.id, dance_set,users) ?? "";
                    valueB = getSkatingPlaces(b?.follower?.id, dance_set,users) ?? "";
                    return Number(valueB) - Number(valueA);
                })
            }
        } else {
            return dance_set_obj;
        }
    }, [dance_set_obj, isDone, isSort])
    const renderStrictlyTable = () => {
        return (
            <div ref={targetRef} style={{width: isPrint ? "1200px" : "auto" }}>
                <Typography align="center" variant="subtitle1">
                    {
                        filters?.event?.event?.name
                        + ' ' + (filters?.dance ?? "")
                        + ' ' + (filters?.category ?? "")
                        + ' ' + (filters?.class ?? "")
                        + ' ' + (filters?.round ?? "")
                        + ' ' + (filters?.final ?? "")
                        + ' ' + (isDone ? 'Результаты ' :'Заход')
                    }
                </Typography>
                <div>
                    <TableContainer component={Paper}  sx={{ maxHeight: (window.innerHeight - 165) + 'px' }}
                    >
                        <Table stickyHeader style={{minWidth: "850px"}}>
                            <TableHead>
                                <TableRow>
                                    <TableCell>{isDone ? "Место в сете" : "Номер захода"}</TableCell>
                                    <TableCell>Номер пары</TableCell>
                                    <TableCell>Leader</TableCell>
                                    <TableCell>Follower</TableCell>
                                    {(!generated && start) ?
                                        <TableCell>{isDone ? "Баллы" : "Судейство"}</TableCell> : ''}
                                    {isDone && (filters?.round === 'fast' || filters?.round === 'hope') ?
                                        <TableCell></TableCell> : ''}

                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {(sortedData ?? []).map((set, index) => {
                                        return (
                                            <TableRow key={`${index+"_"+Date.now()}`} style={{
                                                backgroundColor: (Object.values(set?.jading_status ?? {j: 3}).every(value => value === 2) && !isDone) ? "#008f0029" :
                                                    ((set?.jading_status && !isDone) ? "#ffa50029" : null)
                                            }}
                                                      hover={false}>
                                                <TableCell>{isDone ? index +1 : Math?.trunc((index) / pair_count) + 1}</TableCell>
                                                <TableCell>{set?.number ?? null}</TableCell>
                                                <TableCell>{set?.leader?.name ?? "_"}</TableCell>
                                                <TableCell>{set?.follower?.name ?? "_"}</TableCell>
                                                {!generated && start ?
                                                    (set?.jading_status ?
                                                            <TableCell
                                                                style={{}}>{Object.entries(set?.jading_status).map(([key, value]) => {
                                                                return !isDone ?
                                                                    <AlertDialogNote
                                                                        //style={{maxWidth:1000}}
                                                                        ok={"Понятно"}
                                                                        okFn={()=>{}}
                                                                        cancel=""
                                                                        cancelFn={
                                                                        ()=>{}
                                                            }
                                                                message={
                                                                    <>

                                                                        <ReactMarkdown>
                                                                            {
                                                                                `
##### ${filters?.event?.event?.name
                                                                                + ' ' + (filters?.dance ?? "")
                                                                                + ' ' + (filters?.category ?? "")
                                                                                + ' ' + (filters?.class ?? "")
                                                                                + ' ' + (filters?.round ?? "")
                                                                                + ' ' + (filters?.final ?? "")}
### ${set?.leader?.name} и ${set?.follower?.name}

`}
                                                                        </ReactMarkdown>
                                                                        <div
                                                                            style={{
                                                                                fontSize: "20px",
                                                                            }}>

                                                                        </div>
                                                                        <Table size="small">
                                                                            <TableHead>
                                                                                <TableRow>
                                                                                    <TableCell>Судейская карта</TableCell>
                                                                                    <TableCell>bl</TableCell>
                                                                                    <TableCell>bf</TableCell>
                                                                                    <TableCell>lf</TableCell>
                                                                                    <TableCell>dp</TableCell>
                                                                                    <TableCell>b1</TableCell>
                                                                                    <TableCell>ex</TableCell>
                                                                                    <TableCell>dv</TableCell>
                                                                                    <TableCell>b2</TableCell>
                                                                                    <TableCell>in</TableCell>
                                                                                    <TableCell>sp</TableCell>
                                                                                    <TableCell>b3</TableCell>
                                                                                </TableRow>
                                                                            </TableHead>

                                                                        {Object.entries(set?.jading_status).map(([key, value]) => {
                                                                            return <TableRow>
                                                                                <TableCell>{users_id.find(u => u?._id === key)?.name}</TableCell>
                                                                                <TableCell>{getScore(set?.leader?.id, dance_set, users)?.[key]?.basic_leader}</TableCell>
                                                                                <TableCell>{getScore(set?.leader?.id, dance_set, users)?.[key]?.basic_follow}</TableCell>
                                                                                <TableCell>{getScore(set?.leader?.id, dance_set, users)?.[key]?.lfbdh}</TableCell>
                                                                                <TableCell>{getScore(set?.leader?.id, dance_set, users)?.[key]?.dance_perf}</TableCell>
                                                                                <TableCell>{getScore(set?.leader?.id, dance_set, users)?.[key]?.bonus1}</TableCell>
                                                                                <TableCell>{getScore(set?.leader?.id, dance_set, users)?.[key]?.execution}</TableCell>
                                                                                <TableCell>{getScore(set?.leader?.id, dance_set, users)?.[key]?.diff_var}</TableCell>
                                                                                <TableCell>{getScore(set?.leader?.id, dance_set, users)?.[key]?.bonus2}</TableCell>
                                                                                <TableCell>{getScore(set?.leader?.id, dance_set, users)?.[key]?.interpret}</TableCell>
                                                                                <TableCell>{getScore(set?.leader?.id, dance_set, users)?.[key]?.spontan}</TableCell>
                                                                                <TableCell>{getScore(set?.leader?.id, dance_set, users)?.[key]?.bonus3}</TableCell>
                                                                            </TableRow>

                                                                        })}
                                                                        </Table>
                                                                    </>
                                                                }
                                                                         key={`${key}`}>
                                                                        <div
                                                                            style={{display: "flex", fontSize: "10px"}}
                                                                        >
                                                                        {
                                                                            <div style={{display: "flex"}}>
                                                                                <div style={{
                                                                                    width: '10px',
                                                                                    height: '10px',
                                                                                    backgroundColor: value === 0 ? "red" : (value === 1 ? "yellow" : "green"),
                                                                                    borderRadius: '50%',
                                                                                    marginRight: '2px'
                                                                                }}></div>
                                                                                {users_id.find(u => u?._id === key)?.name}
                                                                            </div>

                                                                        }: {value === 0 ?
                                                                        "Не готов"
                                                                        : (value === 1 ?
                                                                            "Судит" : (
                                                                                value === 2 ?
                                                                                getScore(set?.leader?.id, dance_set, users)?.[key]?.basic_leader.toFixed(1)
                                                                                + '|' + getScore(set?.leader?.id, dance_set, users)?.[key]?.basic_follow.toFixed(1)
                                                                                + '|' + (
                                                                                    getScore(set?.leader?.id, dance_set, users)?.[key]?.lfbdh +
                                                                                    getScore(set?.leader?.id, dance_set, users)?.[key]?.dance_perf +
                                                                                    getScore(set?.leader?.id, dance_set, users)?.[key]?.bonus1 * 1).toFixed(1)
                                                                                + '|' + (
                                                                                    getScore(set?.leader?.id, dance_set, users)?.[key]?.execution +
                                                                                    getScore(set?.leader?.id, dance_set, users)?.[key]?.diff_var +
                                                                                    getScore(set?.leader?.id, dance_set, users)?.[key]?.bonus2 * 1).toFixed(1)
                                                                                + '|' + (
                                                                                    getScore(set?.leader?.id, dance_set, users)?.[key]?.interpret +
                                                                                    getScore(set?.leader?.id, dance_set, users)?.[key]?.spontan +
                                                                                    getScore(set?.leader?.id, dance_set, users)?.[key]?.bonus3 * 1).toFixed(1)

                                                                                : "Что то не так"))}

                                                                        </div>
                                                                    </AlertDialogNote> : ''
                                                            })}
                                                                {!isDone ? (
                                                                        (dance_set?.round === 'fast' || dance_set?.round === 'fast_final') ?
                                                                            <div style={{fontSize: "10px"}}>
                                                                                {dance_set?.round}:
                                                                                {
                                                                                    " " + (roundTo3(getBalls(set?.leader?.id, dance_set, users) + (getBalls(set?.leader?.id, dance_set, users) * 0.1)))
                                                                                    + " + " + dance_set_slow?.round + ": " + fixNaN(getBalls(set?.leader?.id, dance_set_slow, users)) + " → " +
                                                                                    (roundTo3((roundTo3((getBalls(set?.leader?.id, dance_set, users) + (getBalls(set?.leader?.id, dance_set, users) * 0.1)) + getBalls(set?.leader?.id, dance_set_slow, users)) * 65) / 136.5))
                                                                                    || '_'}
                                                                            </div> :
                                                                            <div style={{fontSize: "10px"}}>
                                                                                {dance_set?.round !== "" ? dance_set?.round : "Сумма"}: {getBalls(set?.leader?.id, dance_set, users) || '_'}</div>
                                                                    )
                                                                    : ((dance_set?.round === 'fast' || dance_set?.round === 'fast_final') ?
                                                                            (roundTo3((roundTo3((getBalls(set?.leader?.id, dance_set, users) + (getBalls(set?.leader?.id, dance_set, users) * 0.1)) + getBalls(set?.leader?.id, dance_set_slow, users)) * 65) / 136.5)) || '_'
                                                                            : getBalls(set?.leader?.id, dance_set, users) || '_'

                                                                    )
                                                                }
                                                                { (Object.values(set?.jading_status ?? {j: 3}).every(value => value === 2) || isDone) ?
                                                                    "" :
                                                                <AlertDialog
                                                                    variant={'text'}
                                                                    size={"small"}
                                                                    sx={{mb:-2}}
                                                                    name='Отменить'
                                                                    main_message='Отменить судейство?'
                                                                    message='Это отменит судейство'
                                                                    ok='Отменить'
                                                                    cancel='Подумаю еще'
                                                                    okFn={()=>{cancelDance(
                                                                        set?.number,
                                                                        filters['event']?.event?.value ?? null,
                                                                        filters['dance'] ?? null,
                                                                        filters['category'] ?? null,
                                                                        filters['class'] ?? null,
                                                                        filters['round'] ?? null,
                                                                        set?.number ?? null,
                                                                        set?.leader ?? null,
                                                                        set?.follower ?? null,
                                                                        "leaders"
                                                                    )}}
                                                                    // enabled={isDone}
                                                                /> }
                                                            </TableCell>
                                                            :
                                                            (set?.jading_status === 2 ? <TableCell>done</TableCell> :
                                                                <TableCell><Button disabled={dance_complete} size="small"
                                                                                   onClick={
                                                                                       () => toDance(
                                                                                           set?.number,
                                                                                           filters['event']?.event?.value ?? null,
                                                                                           filters['dance'] ?? null,
                                                                                           filters['category'] ?? null,
                                                                                           filters['class'] ?? null,
                                                                                           filters['round'] ?? null,
                                                                                           set?.number ?? null,
                                                                                           set?.leader ?? null,
                                                                                           set?.follower ?? null,
                                                                                           "leaders"
                                                                                       )}>На танцпол</Button></TableCell>)
                                                    )
                                                    :
                                                    ''
                                                }
                                                {filters?.round === 'fast' || filters?.round === 'hope' ? (isDone ?
                                                    <TableCell>
                                                        {getFinal(set?.leader?.id, dance_set) ? "В финале" : (isEnd ? '' :
                                                            <Button disabled={final_complete} size="small" onClick={
                                                                () => toFinal(
                                                                    index,
                                                                    filters['event']?.event?.value ?? null,
                                                                    filters['dance'] ?? null,
                                                                    filters['category'] ?? null,
                                                                    filters['class'] ?? null,
                                                                    filters['round'] ?? null,
                                                                    set?.number ?? null,
                                                                    set?.leader ?? null,
                                                                    set?.follower ?? null
                                                                )}>В финал</Button>)}
                                                    </TableCell> : '') : ''}
                                            </TableRow>)
                                    }
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </div>
            </div>
        )
    }
    const renderSkatingTable = () => {
        return (
            <div ref={targetRef} style={{width: isPrint ? "1200px" : "auto" }}>
                <Typography align="center" variant="subtitle1">
                    {
                        filters?.event?.event?.name
                        + ' ' + (filters?.dance ?? "")
                        + ' ' + (filters?.category ?? "")
                        + ' ' + (filters?.class ?? "")
                        + ' ' + (filters?.round ?? "")
                        + ' ' + (filters?.final ?? "")
                        + ' ' + (isDone ? 'Результаты ' :'Заход')
                    }
                </Typography>
                {renderSkatingTableOnly()}
            </div>
        )
    }
    const renderSkatingTableOnly = (role, roles) =>{
        return (
                <TableContainer component={Paper} sx={{maxHeight: (window.innerHeight - 165) + 'px'}}
                >
                    <Table stickyHeader style={{minWidth: "350px"}}>
                        <TableHead>
                            <TableRow>
                                <TableCell>{isDone ? "Место в сете" : "Номер захода"}</TableCell>
                                <TableCell>Номер пары</TableCell>
                                { role ? ( role === "leader" ? <TableCell>Leader</TableCell> : "" ) : <TableCell>Leader</TableCell>}
                                { role ? ( role === "follower" ? <TableCell>Follower</TableCell> : "" ) : <TableCell>Follower</TableCell>}
                                {(!generated && start) ?
                                    <TableCell>{isDone ? "" : "Судейство"}</TableCell> : ''}
                                {isDone && (filters?.round === 'fast' || filters?.round === 'hope') ?
                                    <TableCell></TableCell> : ''}
                                {isDone && (filters?.round !== '1') ?
                                    <TableCell padding="normal"></TableCell> : ''}

                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {(
                                (personalFinal && filters?.round === "1") ?
                                    (sortedDataSkatingObj?.[roles ? roles : "leaders"])

                                :  (sortedDataSkating ?? []) )
                                .map((set, index) => {
                                    return (
                                        <TableRow key={`${index}`} style={{
                                            backgroundColor: (Object.values(set?.jading_status ?? {j: 3}).every(value => value === 2) && !isDone) ? "#008f0029" :
                                                ((set?.jading_status && !isDone) ? "#ffa50029" : null)
                                        }}
                                                  hover={false}>
                                            <TableCell>{isDone ? index + 1 : Math?.trunc((index) / pair_count) + 1}</TableCell>
                                            <TableCell>{set?.number ?? null}</TableCell>
                                            { role ? ( role === "leader" ? <TableCell>{set?.leader?.name ?? "_"}</TableCell> : "" ) : <TableCell>{set?.leader?.name ?? "_"}</TableCell>}
                                            { role ? ( role === "follower" ?  <TableCell>{set?.follower?.name ?? "_"}</TableCell> : "" ) : <TableCell>{set?.follower?.name ?? "_"}</TableCell>}


                                            {!generated && start ?
                                                (set?.jading_status ?
                                                    ( personalRound  || filters?.round === "1" ?
                                                        <TableCell // как секйтинг
                                                            style={{}}>{Object.entries(set?.jading_status).map(([key, value]) => {
                                                            return !isDone ?
                                                                <div
                                                                    key={`${key}`}>
                                                                    <div
                                                                        style={{display: "flex", fontSize: "10px"}}
                                                                    >
                                                                        {
                                                                            <div style={{display: "flex"}}>
                                                                                <div style={{
                                                                                    width: '10px',
                                                                                    height: '10px',
                                                                                    backgroundColor: value === 0 ? "red" : (value === 1 ? "yellow" : "green"),
                                                                                    borderRadius: '50%',
                                                                                    marginRight: '2px'
                                                                                }}></div>
                                                                                {users_id?.find(u => u?._id === key)?.name}
                                                                            </div>

                                                                        }: {value === 0 ?
                                                                        "Не готов"
                                                                        : (value === 1 ?
                                                                            "Судит" : (
                                                                                value === 2 ?
                                                                                    getScore(set?.[role ? role : "leader"]?.id, dance_set, users)?.[key]?.skating_place?.toFixed(0)
                                                                                    : "Что то не так"))}

                                                                    </div>
                                                                </div> : ''
                                                        })}
                                                            {!isDone ? getSkatingPlaces(set?.[role ? role : "leader"]?.id, dance_set, users, role ? role : null) : ''}
                                                            {(Object.values(set?.jading_status ?? {j: 3}).every(value => value === 2) || isDone) ?
                                                                "" :
                                                                <AlertDialog
                                                                    variant={'text'}
                                                                    size={"small"}
                                                                    sx={{mb: -2}}
                                                                    name='Отменить'
                                                                    main_message='Отменить судейство?'
                                                                    message='Это отменит судейство'
                                                                    ok='Отменить'
                                                                    cancel='Подумаю еще'
                                                                    okFn={() => {
                                                                        cancelDance(
                                                                            set?.number,
                                                                            filters['event']?.event?.value ?? null,
                                                                            filters['dance'] ?? null,
                                                                            filters['category'] ?? null,
                                                                            filters['class'] ?? null,
                                                                            filters['round'] ?? null,
                                                                            set?.number ?? null,
                                                                            set?.leader ?? null,
                                                                            set?.follower ?? null,
                                                                            role ? role : "leaders"
                                                                        )
                                                                    }}
                                                                    // enabled={isDone}
                                                                />}
                                                        </TableCell> :
                                                            <TableCell
                                                                padding="normal"
                                                                style={{}}>{Object.entries(set?.jading_status).map(([key, value], index) => {
                                                                return (
                                                                    <div style={{
                                                                        display: "flex",
                                                                        fontSize: "10px"
                                                                    }} key={`${key}`}>
                                                                        {
                                                                            <div style={{display: "flex"}}>
                                                                                {!isDone ?
                                                                                    <div style={{
                                                                                        width: '10px',
                                                                                        height: '10px',
                                                                                        backgroundColor: value === 0 ? "red" : (value === 1 ? "yellow" : "green"),
                                                                                        borderRadius: '50%',
                                                                                        marginRight: '2px'
                                                                                    }}></div> : ""}
                                                                                {
                                                                                    !isDone ?
                                                                                        users_id.find(u => u?._id === key)?.name
                                                                                        : "Судья " + (index + 1)
                                                                                }
                                                                            </div>

                                                                        } : {value === 0 ?
                                                                        "Не готов"
                                                                        : (value === 1 ?
                                                                            "Судит" : (value === 2 ?
                                                                                getScore(set?.[role ? role : "leader"]?.id, dance_set, users)?.[key]?.jj === 100 ?
                                                                                    "yes" :
                                                                                    (getScore(set?.[role ? role : "leader"]?.id, dance_set, users)?.[key]?.jj === 51 ? "maybe" : "_")

                                                                                : "Что то не так"))}</div>)
                                                            })}

                                                                {<div
                                                                    style={{fontSize: "10px"}}>Сумма: {getBallsJJ(set?.[role ? role : "leader"]?.id, dance_set, users)} </div>}
                                                                {!isDone ?
                                                                    <AlertDialog
                                                                        variant={'text'}
                                                                        size={"small"}
                                                                        sx={{mb: -2}}
                                                                        name='Отменить'
                                                                        main_message='Отменить судейство?'
                                                                        message='Это отменит судейство'
                                                                        ok='Отменить'
                                                                        cancel='Подумаю еще'
                                                                        okFn={() => {
                                                                            cancelDance(
                                                                                set?.number,
                                                                                filters['event']?.event?.value ?? null,
                                                                                filters['dance'] ?? null,
                                                                                filters['category'] ?? null,
                                                                                filters['class'] ?? null,
                                                                                filters['round'] ?? null,
                                                                                set?.number ?? null,
                                                                                set?.[role ? role : "leader"] ?? null,
                                                                                set?.follower ?? null,
                                                                                roles ? roles : "leaders"
                                                                            )
                                                                        }}
                                                                    /> : ''
                                                                }
                                                            </TableCell>
                                                    )
                                                        :
                                                        (set?.jading_status === 2 ? <TableCell>done</TableCell> :
                                                            <TableCell><Button disabled={dance_complete} size="small"
                                                                               onClick={
                                                                                   () => toDance(
                                                                                       set?.number,
                                                                                       filters['event']?.event?.value ?? null,
                                                                                       filters['dance'] ?? null,
                                                                                       filters['category'] ?? null,
                                                                                       filters['class'] ?? null,
                                                                                       filters['round'] ?? null,
                                                                                       set?.number ?? null,
                                                                                       set?.leader ?? null,
                                                                                       set?.follower ?? null,
                                                                                       roles ? roles : "leaders"
                                                                                   )}>На танцпол</Button></TableCell>)
                                                )
                                                :
                                                ''
                                            }
                                            { isDone && (filters?.round !== '1') ?
                                                <TableCell>
                                                    {getRoundAccess(set?.[role ? role : "leader"]?.id, dance_set, getNextRound(filters['round']) ) ?
                                                        (
                                                            <AlertDialog
                                                                variant={'text'}
                                                                name={"в " + (getNextRound(filters['round']) === "1" ? "финале" : getNextRound(filters['round']))}
                                                                main_message={"Отмена перевода в " + (getNextRound(filters['round']) === "1" ? "финал" : getNextRound(filters['round']))}
                                                                message={"Перевод в  " + (getNextRound(filters['round']) === "1" ? "финал" : getNextRound(filters['round'])) + ' будет отменен'}
                                                                ok='Отменить?'
                                                                cancel='Подумаю еще'
                                                                okFn={
                                                                    () => toNextRoundCancel(
                                                                        index,
                                                                        filters['event']?.event?.value ?? null,
                                                                        filters['dance'] ?? null,
                                                                        filters['category'] ?? null,
                                                                        filters['class'] ?? null,
                                                                        filters['round'] ?? null,
                                                                        set?.number ?? null,
                                                                        set?.[role ? role : "leader"] ?? null,
                                                                        set?.follower ?? null,
                                                                    )}
                                                                enabled={final_complete}
                                                            />
                                                        ) : (isEnd ? '' :
                                                            <Button disabled={final_complete} size="small"
                                                                    onClick={
                                                                        () => toNextRound(
                                                                            index,
                                                                            filters['event']?.event?.value ?? null,
                                                                            filters['dance'] ?? null,
                                                                            filters['category'] ?? null,
                                                                            filters['class'] ?? null,
                                                                            filters['round'] ?? null,
                                                                            set?.number ?? null,
                                                                            set?.[role ? role : "leader"] ?? null,
                                                                            set?.follower ?? null,
                                                                        )}>Провести</Button>)}
                                                </TableCell> : ''}
                                        </TableRow>)
                                }
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
        )
    }
    const JJTable = ({typeName, typeValue, typeValueMany}) => {
        return (
            <TableContainer component={Paper}>
                <Table style={{minWidth: "400px"}}>
                    <TableHead>
                        <TableRow>
                            <TableCell padding="checkbox" sx={{
                                pl: 2,
                                width: "80px"
                            }}>{isDone ? "Место" : "Заход"}</TableCell>
                            <TableCell padding="normal">№</TableCell>
                            <TableCell padding="normal">{typeName}</TableCell>
                            {(!generated && start) ?
                                <TableCell
                                    padding="normal">{isDone ? "Баллы" : "Судейство"}</TableCell> : ''}
                            {isDone && (filters?.round !== '1') ?
                                <TableCell padding="normal"></TableCell> : ''}

                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {(sortedDataObj?.[typeValueMany] ?? []).map((set, index) => {
                            if ((Math?.trunc((index) / pair_count) + 1) === selectListRound || selectListRound === 0)
                                return (
                                    set?.[typeValue]?.id ?
                                        <TableRow key={`${index}`} style={{
                                            backgroundColor: (Object.values(set?.jading_status ?? {j: 3}).every(value => value === 2) && !isDone) ? "#008f0029" :
                                                ((set?.jading_status && !isDone) ? "#ffa50029" : null)
                                        }}
                                                  hover={false}>
                                            <TableCell>{isDone ? index + 1 : Math?.trunc((index) / pair_count) + 1}</TableCell>
                                            <TableCell padding="normal"
                                            >{set?.number ?? null}</TableCell>
                                            <TableCell
                                                padding="normal">{set?.[typeValue]?.name ?? "_"}</TableCell>
                                            {!generated && start ?
                                                (set?.jading_status ?
                                                        <TableCell
                                                            padding="normal"
                                                            style={{}}>{Object.entries(set?.jading_status).map(([key, value], index) => {
                                                            return (
                                                                <div style={{
                                                                    display: "flex",
                                                                    fontSize: "10px"
                                                                }} key={`${key}`}>
                                                                    {
                                                                        <div style={{display: "flex"}}>
                                                                            {!isDone ?
                                                                                <div style={{
                                                                                    width: '10px',
                                                                                    height: '10px',
                                                                                    backgroundColor: value === 0 ? "red" : (value === 1 ? "yellow" : "green"),
                                                                                    borderRadius: '50%',
                                                                                    marginRight: '2px'
                                                                                }}></div> : ""}
                                                                            {
                                                                                !isDone ?
                                                                                    users_id.find(u => u?._id === key)?.name
                                                                                    : "Судья " + (index + 1)
                                                                            }
                                                                        </div>

                                                                    } : {value === 0 ?
                                                                    "Не готов"
                                                                    : (value === 1 ?
                                                                        "Судит" : (value === 2 ?
                                                                            getScore(set?.[typeValue]?.id, dance_set, users)?.[key]?.jj === 100 ?
                                                                                "yes" :
                                                                                (getScore(set?.[typeValue]?.id, dance_set, users)?.[key]?.jj === 51 ? "maybe" : "_")

                                                                            : "Что то не так"))}</div>)
                                                        })}

                                                            {<div
                                                                style={{fontSize: "10px"}}>Сумма: {getBallsJJ(set?.[typeValue]?.id, dance_set, users)} </div>}
                                                            {!isDone ?
                                                                <AlertDialog
                                                                    variant={'text'}
                                                                    size={"small"}
                                                                    sx={{mb: -2}}
                                                                    name='Отменить'
                                                                    main_message='Отменить судейство?'
                                                                    message='Это отменит судейство'
                                                                    ok='Отменить'
                                                                    cancel='Подумаю еще'
                                                                    okFn={() => {
                                                                        cancelDance(
                                                                            set?.number,
                                                                            filters['event']?.event?.value ?? null,
                                                                            filters['dance'] ?? null,
                                                                            filters['category'] ?? null,
                                                                            filters['class'] ?? null,
                                                                            filters['round'] ?? null,
                                                                            set?.number ?? null,
                                                                            set?.[typeValue] ?? null,
                                                                            set?.follower ?? null,
                                                                            typeValueMany
                                                                        )
                                                                    }}
                                                                /> : ''
                                                            }
                                                        </TableCell>
                                                        :
                                                        (set?.jading_status === 2 ?
                                                            <TableCell>done</TableCell> :
                                                            <TableCell padding="normal"><Button
                                                                disabled={dance_complete} size="small"
                                                                onClick={
                                                                    () => toDance(
                                                                        set?.number,
                                                                        filters['event']?.event?.value ?? null,
                                                                        filters['dance'] ?? null,
                                                                        filters['category'] ?? null,
                                                                        filters['class'] ?? null,
                                                                        filters['round'] ?? null,
                                                                        set?.number ?? null,
                                                                        set?.[typeValue] ?? null,
                                                                        set?.follower ?? null,
                                                                        typeValueMany
                                                                    )}>На танцпол</Button></TableCell>)
                                                    )
                                                    :
                                                    ''
                                                }
                                                { isDone && (filters?.round !== '1') ?
                                                    <TableCell>
                                                        {getRoundAccess(set?.[typeValue]?.id, dance_set, getNextRound(filters['round']) ) ?
                                                            (
                                                                <AlertDialog
                                                                    variant={'text'}
                                                                    name={"в " + (getNextRound(filters['round']) === "1" ? "финале" : getNextRound(filters['round']))}
                                                                    main_message={"Отмена перевода в " + (getNextRound(filters['round']) === "1" ? "финал" : getNextRound(filters['round']))}
                                                                    message={"Перевод в  " + (getNextRound(filters['round']) === "1" ? "финал" : getNextRound(filters['round'])) + ' будет отменен'}
                                                                    ok='Отменить?'
                                                                    cancel='Подумаю еще'
                                                                    okFn={
                                                                        () => toNextRoundCancel(
                                                                            index,
                                                                            filters['event']?.event?.value ?? null,
                                                                            filters['dance'] ?? null,
                                                                            filters['category'] ?? null,
                                                                            filters['class'] ?? null,
                                                                            filters['round'] ?? null,
                                                                            set?.number ?? null,
                                                                            set?.[typeValue] ?? null
                                                                        )}
                                                                    enabled={final_complete}
                                                                />
                                                            ) : (isEnd ? '' :
                                                            <Button disabled={final_complete} size="small"
                                                                    onClick={
                                                                        () => toNextRound(
                                                                            index,
                                                                            filters['event']?.event?.value ?? null,
                                                                            filters['dance'] ?? null,
                                                                            filters['category'] ?? null,
                                                                            filters['class'] ?? null,
                                                                            filters['round'] ?? null,
                                                                            set?.number ?? null,
                                                                            set?.[typeValue] ?? null
                                                                        )}>Провести</Button>)}
                                                    </TableCell> : ''}
                                            </TableRow> : "")
                            }
                        )}
                    </TableBody>
                </Table>
            </TableContainer>
        )
    }
    const renderJJTable = () => {
        return (
            <Stack>
                <Stack direction={"column"} alignItems="center">
                </Stack>
                <div ref={targetRef} style={{width: isPrint ? "1200px" : "auto"}}>
                    <Typography align="center" variant="subtitle1">
                        {
                            filters?.event?.event?.name
                            + ' ' + (filters?.dance ?? "")
                            + ' ' + (filters?.category ?? "")
                            + ' ' + (filters?.class ?? "")
                            + ' ' + ((filters?.round === "1"? "Финал" : filters?.round ) ?? "")
                                + ((selectListRound !== 0) ? " Заход " + selectListRound : '')
                            + ' ' + (isDone ? ' Результаты ' :'')
                        }
                    </Typography>
                    <div
                    >
                        {(filters?.round === "1" && !personalFinal) || !personalRound ?  renderSkatingTableOnly() :
                            <Stack sx={{mt: 0}} direction="row" padding={0} justifyContent="space-between" spacing={1}>
                                {filters.round === "1" ? renderSkatingTableOnly("leader","leaders") : <JJTable typeName="Leader" typeValue="leader" typeValueMany="leaders"/>}
                                {filters.round === "1" ? renderSkatingTableOnly("follower","followers") : <JJTable typeName="Followers" typeValue="follower" typeValueMany="followers"/>}
                            </Stack>
                        }

                    </div>
                </div>
            </Stack>

        )
    }
    const RenderTable = () => {
        //console.log(filters?.category)
        switch (filters?.category) {
            case "Strictly":
                return (renderStrictlyTable())
            case "J&J":
                return (renderJJTable())
            default:
                switch (judType) {
                    case "Strictly":
                        return (renderStrictlyTable())
                    case "J&J":
                        return (renderJJTable())
                    case "Skating":
                        return (renderSkatingTable())
                }
        }
    }
    const getPairWord = (count) => {
        const mod10 = count % 10;
        const mod100 = count % 100;
        if (mod10 === 1 && mod100 !== 11) return 'пара';
        if (mod10 >= 2 && mod10 <= 4 && (mod100 < 10 || mod100 >= 20)) return 'пары';
        return 'пар';
    }
    const renderStrictlyButtons = () => {
        return (
            <div
                style={{
                    position: 'fixed',
                    zIndex: '10',
                    marginLeft: "50px",
                    marginTop: "-50px",
                    minWidth:1024
                }}
            >
                <ExpandMore
                    // sx={{height:"1px",
                    //     width:"100%",
                    //         borderRadius:"0"
                    //     }}
                    expand={openCollapse}
                    onClick={handleExpandClick}
                    aria-expanded={openCollapse}
                    aria-label="show more"
                ><ExpandMoreIcon/>
                </ExpandMore>
                <Button onClick={getSet}> Получить </Button>
                {!generated ?
                    <AlertDialog
                        variant={'text'}
                        name='Удалить'
                        main_message='Удалить состояние заходов?'
                        message='Результаты судейста не будут удалены, но судейство будет выполнено повторно по всем заходам'
                        ok='Удалить'
                        cancel='Подумаю еще'
                        okFn={rmSet}
                        // enabled={isDone}
                    />
                    : ''}
                {!generated ? <Button disabled={start} onClick={() => {
                    setStart(!start)
                }}>Судейство</Button> : ''}
                {start && !generated ? <Button onClick={() => setMassDialogOpen(true)}>На танцпол</Button> : ''}
                {/*{!generated ? <Button variant={isSort ? "contained" : "text"} onClick={() => {*/}
                {/*    setIsSort(!isSort)*/}
                {/*}}>сортировка</Button> : ''}*/}
                {generated ? <ButtonGroup variant="text" aria-label="Basic button group">
                    <AlertDialog
                        //onOpen={getAllUsers}
                        variant={'text'}
                        name={`Судьи ${(selectedJudges?.leaders?.length)}`}
                        main_message={<JudgeSelector
                            selector_type="Strictly"
                            judgesList={users_id}
                            edit={true}
                            selectedJudges={selectedJudges}
                            onChange={(newSelection)=>{
                                setSelectedJudges(newSelection)
                            }}
                        />}
                        message=""
                        ok='Сохранить'
                        cancel=''
                        okFn={() => {
                        }}
                        // enabled={isDone}
                    />
                    <Button disabled={pair_count === 1} onClick={() => setPairCount(1)}>Одна пара</Button>
                    <Button disabled={pair_count === 2} onClick={() => setPairCount(2)}>Две пары</Button>
                    <Button disabled={(selectedJudges?.leaders?.length) < 1} onClick={shuffleDanceSet}>Перемешать и создать</Button>
                </ButtonGroup> : ""}
                {sortedData?.every(item => Object?.values(item?.jading_status ?? [{e: 0}])?.every(status => status === 2))
                    ? <Button disabled={isDone} onClick={() => {
                        setIsDone(!isDone)
                    }}>Подсчитать</Button> : ''}
                {sortedData?.every(item => Object?.values(item?.jading_status ?? [{e: 0}])?.every(status => status === 2))
                    ? <Button disabled={isEnd} onClick={() => {
                        setIsEnd(!isEnd)
                    }}>Готово</Button> : ''}
                {isDone ? <Button onClick={() => setMassNextRoundDialogOpen(true)}>Провести</Button> : ''}
                <Button onClick={()=>{setPersonalRound(!personalRound)}}>
                    { personalRound ? "Персональный раунд": "Парный раунд"} </Button>
                {/*<Button onClick={changeJudType}>*/}
                {/*    {judType} </Button>*/}
                <Button onClick={() => printPDF(
                )}> PDF </Button>
            </div>
        )
    }
    const renderJJButtons = () => {
        return (
            <div
                style={{
                    position: 'fixed',
                    zIndex: '10',
                    marginLeft: "50px",
                    marginTop: "-50px",
                    minWidth:1024
                }}
            >
                <ExpandMore
                    expand={openCollapse}
                    onClick={handleExpandClick}
                    aria-expanded={openCollapse}
                    aria-label="show more"
                ><ExpandMoreIcon/>
                </ExpandMore>
                <Button onClick={getSet}> Получить </Button>
                {!generated ?
                    <AlertDialog
                        variant={'text'}
                        name='Удалить'
                        main_message='Удалить состояние заходов?'
                        message='Результаты судейста не будут удалены, но судейство будет выполнено повторно по всем заходам'
                        ok='Удалить'
                        cancel='Подумаю еще'
                        okFn={rmSet}
                        // enabled={isDone}
                    />
                    : ''}
                {!generated ? <Button disabled={start} onClick={() => {
                    setStart(!start)
                }}>Судейство</Button> : ''}
                {start && !generated ? <Button onClick={() => setMassDialogOpen(true)}>На танцпол</Button> : ''}
                {/*{!generated ? <Button variant={isSort ? "contained" : "text"} onClick={() => {*/}
                {/*    setIsSort(!isSort)*/}
                {/*}}>сортировка</Button> : ''}*/}
                {!generated ?
                    <AlertDialog
                        variant={'text'}
                        name='Завершить'
                        main_message='Все заходы будут завершены'
                        message='Судьи смогут отправить оценки'
                        ok='Завершить'
                        cancel='Подумаю еще'
                        okFn={endDanceSet}
                        enabled={isEndJudging}
                    />
                    : ''}
                {generated ? <ButtonGroup variant="text" aria-label="Basic button group">
                    <AlertDialog
                        variant={'text'}
                        name={`Судьи ${(selectedJudges?.leaders?.length + selectedJudges?.followers?.length)}`}
                        main_message={
                            <JudgeSelector
                                judgesList={users_id}
                                edit={true}
                                selectedJudges={selectedJudges}
                                onChange={(newSelection) => setSelectedJudges(newSelection)}
                            />}
                        message=""
                        ok='Сохранить'
                        cancel=''
                        okFn={() => {
                        }}
                        // enabled={isDone}
                    />
                    <DigitDialog
                        button_label={`В заходе ${pair_count} ${getPairWord(pair_count)}`}
                        setFn={setPairCount}
                    />
                    <AlertDialog
                        variant={'text'}
                        name={`Yes ${jjBalls?.yes} | Maybe ${jjBalls?.maybe}`}
                        main_message={selectYesMaybe()}
                        message=""
                        ok='Сохранить'
                        cancel=''
                        okFn={() => {
                        }}
                        // enabled={isDone}
                    />
                    {/*<Button onClick={shuffleDanceSet}>Перемешать и создать</Button>*/}
                    <AlertDialog
                        variant={'text'}
                        name='Перемешать и создать'
                        main_message={jjSetSummary()}
                        message=''
                        ok='Перемешать и создать'
                        cancel='Подумаю еще'
                        okFn={() => {
                            shuffleDanceSet()
                        }}
                        enabled={(selectedJudges?.leaders?.length + selectedJudges?.followers?.length) < 2}
                    />
                </ButtonGroup> : ""}

                {
                         (sortedDataObj?.leaders ?? []).every(item => Object?.values(item?.jading_status ?? [{e: 0}])?.every(status => status === 2)) //&&
                        //(personalRound ? (sortedDataObj?.followers ?? []) : (sortedDataObj?.leaders ?? [])).every(item => Object?.values(item?.jading_status ?? [{e: 0}])?.every(status => status === 2))
                        ?
                        <Button disabled={isDone} onClick={() => {
                            setIsDone(!isDone)
                        }}>Подсчитать</Button> : ''}
                {((sortedDataObj?.leaders ?? []).every(item => Object?.values(item?.jading_status ?? [{e: 0}])?.every(status => status === 2)) &&
                    ( personalRound ? (sortedDataObj?.followers ?? []) : (sortedDataObj?.leaders ?? []) ).every(item => Object?.values(item?.jading_status ?? [{e: 0}])?.every(status => status === 2)))
                    ? <Button disabled={isEnd} onClick={() => {
                        setIsEnd(!isEnd)
                    }}>Готово</Button> : ''}
                {isDone ? <Button onClick={() => setMassNextRoundDialogOpen(true)}>Провести</Button> : ''}
                <ButtonGroup variant={"text"} >
                    <Button
                        variant={selectListRound === 0 ? "contained" : "text"}
                        onClick={() => {
                            setSelectListRound(0)
                        }}  key={0}>ВСЕ</Button>
                    {Array.from({
                        length:
                            Math.ceil((
                                sortedDataObj?.leaders.length > sortedDataObj?.followers.length ?
                                    sortedDataObj?.leaders.length :
                                    sortedDataObj?.followers.length
                            ) / (pair_count))
                    }, (_, i) => i + 1).map((i) => {
                        return <Button variant={selectListRound === i ? "contained" : "text"}
                                       onClick={() => {
                                           setSelectListRound(i)
                                       }} size={"small"} key={i}>{i}</Button>
                    })}
                </ButtonGroup>
                <Button onClick={()=>{setPersonalRound(!personalRound)}}>
                    {personalRound ? "Персональный раунд": "Парный раунд"} </Button>
                <Button onClick={()=>{setPersonalFinal(!personalFinal)}}>
                    {personalFinal ? "След. раунд персональный": "След. раунд парный"} </Button>

                <Button onClick={() => printPDF(
                )}> PDF </Button>
            </div>
        )
    }
    const selectYesMaybe = () => {
        return (
            <Box sx={{width: 200, display: 'flex', flexDirection: 'column', gap: 2, ml: 0}}>
                <Typography variant="h6">Выбор оценок J&J</Typography>
                <FormControl>
                    <TextField
                        type={"number"}
                        id="1"
                        label="Сколько YES"
                        variant="outlined"
                        autoComplete={"off"}
                        value={jjBalls?.yes}
                        onChange={(e) => {
                            setJjBalls({...jjBalls, yes: e.target.value})
                        }}
                    />
                </FormControl>
                <FormControl>
                    <TextField
                        type={"number"}
                        id="2"
                        label="Сколько MAYBE"
                        variant="outlined"
                        autoComplete={"off"}
                        value={jjBalls?.maybe}
                        onChange={(e) => {
                            setJjBalls({...jjBalls, maybe: e.target.value})
                        }}
                    />
                </FormControl>
            </Box>
        );
    }
    const jjSetSummary = () => {
        const getUserName = (id) => users_id?.find(u => u?._id === id)?.name || '—';

        return (
            <Box sx={{my: 3}}>
                <Typography variant="h6" gutterBottom>
                    Заход J&J параметры:
                </Typography>
                <TableContainer component={Paper} sx={{maxWidth: 600}}>
                    <Table size="small">
                        <TableBody>
                            <TableRow>
                                <TableCell><strong>Пар на танцполе</strong></TableCell>
                                <TableCell>{pair_count}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell><strong>Оценки</strong></TableCell>
                                <TableCell>
                                    Yes: {jjBalls?.yes ?? 0} | Maybe: {jjBalls?.maybe ?? 0}
                                </TableCell>
                            </TableRow>

                            <TableRow>
                                <TableCell colSpan={2} sx={{pt: 2}}>
                                    <Typography variant="subtitle1"><strong>Судьи лидеров</strong></Typography>
                                </TableCell>
                            </TableRow>
                            {selectedJudges?.leaders?.map((id, index) => (
                                <TableRow key={`leader-${index}`}>
                                    <TableCell sx={{pl: 4}} colSpan={2}>
                                        {getUserName(id)}
                                    </TableCell>
                                </TableRow>
                            ))}

                            <TableRow>
                                <TableCell colSpan={2} sx={{pt: 2}}>
                                    <Typography variant="subtitle1"><strong>Судьи фолловеров</strong></Typography>
                                </TableCell>
                            </TableRow>
                            {selectedJudges?.followers?.map((id, index) => (
                                <TableRow key={`follower-${index}`}>
                                    <TableCell sx={{pl: 4}} colSpan={2}>
                                        {getUserName(id)}
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Box>
        );
    }
    const renderButtons = () => {
        // console.log("filters",filters)
        // console.log("judType",judType)

        switch (filters?.category) {
            case "Strictly":
                return (renderStrictlyButtons())
            case "J&J":
                return (renderJJButtons())
            default:
                switch (judType) {
                    case "Strictly":
                        return (renderStrictlyButtons())
                    case "J&J":
                        return (!personalFinal && filters?.round === "1") ?  (renderStrictlyButtons()) : (renderJJButtons())
                    case "Skating":
                        return (renderStrictlyButtons())
                }
        }
    }

    const [openCollapse, setOpenCollapse] = useState(true)
    const handleExpandClick = () => {
        setOpenCollapse(!openCollapse);
    }
    const ExpandMore = styled((props) => {
        const {expand, ...other} = props;
        return <IconButton {...other} />;
    })(({theme}) => ({
        marginLeft: 'auto',
        transition: theme.transitions.create('transform', {
            duration: theme.transitions.duration.shortest,
        }),
        variants: [
            {
                props: ({expand}) => !expand,
                style: {
                    transform: 'rotate(0deg)',
                },
            },
            {
                props: ({expand}) => !!expand,
                style: {
                    transform: 'rotate(180deg)',
                },
            },
        ],
    }));
    const renderFiler = () => {
        return (
            <>
                <Collapse in={openCollapse} timeout="auto" unmountOnExit>
                    {
                        events.length > 0 ?
                            <div style={{display: "flex", gap: "10px", marginBottom: "10px", flexWrap: "wrap"}}>
                                <FormControl fullWidth size="small">
                                    <InputLabel>Событие</InputLabel>
                                    <Select
                                        key="event-select"
                                        value={filters["event"]?.event?.value || ""} // Используем только строковое значение
                                        onChange={(event) => {
                                            const selectedEvent = events.find(e => e.event?.value === event.target.value);
                                            //console.log(selectedEvent,event,events)
                                            const tmp = {
                                                event: selectedEvent || null, // Сохраняем весь объект события
                                                dance: null,
                                                category: null,
                                                class: null
                                            }
                                            setFilters(tmp);
                                            filters_ref.current = tmp
                                            //getSetR()
                                        }}// Обнуляем другие фильтры
                                        label="Событие"
                                    >
                                        {events.map((e, index) => (
                                            <MenuItem key={index} value={e?.event?.value}>
                                                {e?.event?.name}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                                <FormControl fullWidth size="small">
                                    <InputLabel>Танец</InputLabel>
                                    <Select
                                        key="dance-select"
                                        value={filters["dance"] || ""}
                                        onChange={(event) => {
                                            setFilters({
                                                ...filters,
                                                dance: event.target.value,
                                                category: "",
                                                class: "",
                                                round: ""
                                            })
                                            filters_ref.current = {
                                                ...filters,
                                                dance: event.target.value,
                                                category: "",
                                                class: "",
                                                round: ""
                                            }
                                            //getSetR()
                                        }}// Сохраняем танец
                                        label="Танец"
                                    >
                                        {events.filter(ev => ev.event.value === filters["event"]?.event?.value)[0]?.dancesList?.map((dance, index) => (
                                            <MenuItem key={index} value={dance}>
                                                {dance}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                                <FormControl fullWidth size="small">
                                    <InputLabel>Категория</InputLabel>
                                    <Select
                                        key="category-select"
                                        value={filters["category"] || ""}
                                        onChange={(event) => {
                                            setFilters({...filters, category: event.target.value, class: "", round: ""})
                                            filters_ref.current = {
                                                ...filters,
                                                category: event.target.value,
                                                class: "",
                                                round: ""
                                            }
                                            //getSetR()
                                        }} // Сохраняем категорию
                                        label="Категория"
                                    >
                                        {events.filter(ev => ev.event.value === filters["event"]?.event?.value)[0]?.categoriesList?.[filters["dance"]]?.map((category, index) => (
                                            <MenuItem key={index} value={category?.name}>
                                                {category?.name}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                                <FormControl fullWidth size="small">
                                    <InputLabel>Класс</InputLabel>
                                    <Select
                                        key="class-select"
                                        value={filters["class"] || ""}
                                        onChange={(event) => {
                                            setFilters({...filters, class: event.target.value, round: ""})
                                            filters_ref.current = {...filters, class: event.target.value, round: ""}
                                            //getSetR()
                                        }} // Сохраняем класс
                                        label="Класс"
                                    >
                                        {events.filter(ev => ev.event.value === filters["event"]?.event?.value)[0]?.["classList"]?.[filters["dance"]]?.[filters["category"]]?.map((classItem, index) => (
                                            <MenuItem key={index} value={classItem}>
                                                {classItem}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                                {rounds().length > 0 ?
                                    <FormControl fullWidth size="small">
                                        <InputLabel>{"Этап"}</InputLabel>
                                        <Select
                                            key="round-select"
                                            value={filters["round"] || ""}
                                            defaultValue={''}
                                            onChange={(event) => {
                                                setFilters({...filters, round: event.target.value})
                                                filters_ref.current = {...filters, round: event.target.value}
                                                getSetR()
                                            }} // Сохраняем round
                                            label="Программа"
                                        >
                                            {(rounds()).map((roundItem, index) => (
                                                <MenuItem key={index} value={roundItem}>
                                                    {roundItem}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                    : ''
                                }
                            </div> : ''}
                </Collapse>
            </>
        )
    }
    return (
        <Box margin={"10px"}
             // onScroll={() => {
             //     setOpenCollapse(false)
             // }}
             sx={{
            //position:"fixed",
            margin: "auto",
            mt: 0,
            ml: 1,
            mr: 1,
            p: 0,
            //width:"98%",
            overflow: 'auto',
            height: (window.innerHeight - 75) + 'px'
        }}>
            <BlurredComponent_all isBlurred={(!isConnected || loading)} message={isConnected ? progress + "%" : "Все будет хорошо, но сейчас нет связи с сервером!"}>

            </BlurredComponent_all>
            {renderButtons()}
            {renderFiler()}
            <RenderTable/>
            <MassDanceDialog
                open={massDialogOpen}
                onClose={() => setMassDialogOpen(false)}
                maxPairs={(filters?.category === "J&J" || judType === "J&J")
                    ? (sortedDataObj?.leaders?.length ?? 0) + (sortedDataObj?.followers?.length ?? 0)
                    : (sortedData?.length ?? 50)}
                onSend={(count) => {
                    const roles = (filters?.category === "J&J" || judType === "J&J") ? "leaders" : "leaders";
                    toDanceMass(
                        count,
                        filters['event']?.event?.value ?? null,
                        filters['dance'] ?? null,
                        filters['category'] ?? null,
                        filters['class'] ?? null,
                        filters['round'] ?? null,
                        roles
                    );
                }}
                onRemoveAll={() => {
                    cancelDanceMass(
                        filters['event']?.event?.value ?? null,
                        filters['dance'] ?? null,
                        filters['category'] ?? null,
                        filters['class'] ?? null,
                        filters['round'] ?? null,
                    );
                }}
            />
            <MassNextRoundDialog
                open={massNextRoundDialogOpen}
                onClose={() => setMassNextRoundDialogOpen(false)}
                onRemoveAll={() => {
                    cancelNextRoundMass(
                        filters['event']?.event?.value ?? null,
                        filters['dance'] ?? null,
                        filters['category'] ?? null,
                        filters['class'] ?? null,
                        filters['round'] ?? null,
                    );
                }}
                maxPairs={(filters?.category === "J&J" || judType === "J&J")
                    ? (sortedDataObj?.leaders?.length ?? 0) + (sortedDataObj?.followers?.length ?? 0)
                    : (sortedData?.length ?? 50)}
                nextRound={getNextRound(filters['round'] ?? null)}
                onSend={(count) => {
                    toNextRoundMass(
                        count,
                        filters['event']?.event?.value ?? null,
                        filters['dance'] ?? null,
                        filters['category'] ?? null,
                        filters['class'] ?? null,
                        filters['round'] ?? null,
                        personalFinal,
                        personalRound
                    );
                }}
            />
        </Box>
    );
};

export default Sets;
